import React, { useContext } from 'react';
import PlayerInsightButton from '../../PlayerInsightButton/PlayerInsightButton';
import { LocalizationContext } from '../../../context/localizationContext';
import { insightsContext } from '../../../context/insightsContext';
import APIClient from '../../../helpers/APIClient';
import Styles from './AccountFound.module.scss';
import checkmark from '../../../assets/images/icons/checkmark.svg';

const AccountFound = (props) => {
  const { setLoading } = props;
  const localization = useContext(LocalizationContext);
  const { tileText } = localization;
  const { description, emailText } = tileText;
  const { agreeToTerms } = emailText;
  const {
    accountFound,
    accountFoundMessage,
    boldDescription,
    continueAndAcceptBtn,
  } = description;
  const insights = useContext(insightsContext);
  const { dispatch } = insights;

  const acceptTerms = () => {
    setLoading(true);
    APIClient.userAcceptTerms((response) => {
      if (response?.status === 200) {
        dispatch({
          type: 'ACCEPT_TERMS',
        });
      }
    });
  };

  return (
    <div className={Styles.accountFound}>
      <div className={Styles.boldDescription}>{boldDescription}</div>
      <div className={Styles.title}>
        <img src={checkmark} />
        <div>{accountFound}</div>
      </div>
      <div className={Styles.accountFoundMessage}>{accountFoundMessage}</div>
      <PlayerInsightButton
        label={continueAndAcceptBtn}
        onClick={() => acceptTerms()}
      />
      <div
        className={Styles.agreeToTerms}
        dangerouslySetInnerHTML={{
          __html: agreeToTerms,
        }}
      ></div>
    </div>
  );
};

export default AccountFound;
